import React from "react";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import * as anchorClasse from "../../styles/communs/anchor.module.scss";

const Anchor = ({anchor, ...props}) => {
    if (anchor) {
        if (anchor.charAt(0) !== '#') {
            anchor = `#${anchor}`
        }
        const title = props.title || `Section ${anchor}`
        const clx = props.className || anchorClasse.anchor
        const onAnchorLinkClick = props.onAnchorLinkClick || undefined

        return (
            <AnchorLink
                to={anchor} title={title} className={clx} onAnchorLinkClick={onAnchorLinkClick}/>
        )
    }
    return (
        <>
        </>
    )
}

export default Anchor